<template>
    <div>
        <b-alert show variant="warning">
            <div class="flex flex-col items-center">
                <div>
                    <p>This platform this service operates on has been deprecated and is no longer receiving support. Certain operations, such as virtual consoles and remote power management, may cease to function.</p>
                    <p>We recommend upgrading to a modern Cloud Server to receive the benefits of dual zone (HA), improved performance, and ongoing platform support. Contact Sales for more information.</p>
                </div>
                <div>
                    <b-button variant="primary" href="https://www.serversaustralia.com.au/products/cloud-servers" target="_blank">View our Cloud Servers</b-button>
                    <b-button variant="outline-secondary" outline href="mailto:sales@serversaustralia.com.au">Contact Sales</b-button>
                </div>
            </div>
        </b-alert>

        <!-- Status -->
        <sau-service-status :service="service"></sau-service-status>

        <!-- System Details -->
        <sau-service-common-system :service="service" class="pt-6"></sau-service-common-system>

        <!-- CPU Usage -->
        <sau-vps-oa-cpu-usage :service="service" class="pt-6"></sau-vps-oa-cpu-usage>

        <!-- Vps Transactions -->
        <sau-vps-oa-transactions :service="service" class="pt-6"></sau-vps-oa-transactions>
    </div>
</template>

<script>
import VpsOaCpuUsage from './_CpuUsage';
import VpsOaTransactions from './_Transactions';

export default {
    props: ['service'],
    components: {
        'sau-vps-oa-cpu-usage': VpsOaCpuUsage,
        'sau-vps-oa-transactions': VpsOaTransactions,
    }
};
</script>
